import React, { useMemo } from 'react'
import { IntercomProvider as ProviderLib } from 'react-use-intercom'
import settings, { APP_ENV } from 'shared/common/settings'

interface Props {
  children?: React.ReactNode
}

const IntercomApps: Map<APP_ENV, string> = new Map([
  ['development', 'vtlfk4ov'],
  ['staging', 'vtlfk4ov'],
  ['production', 'crui9hdm'],
])

export const IntercomProvider: React.FC<Props> = ({ children }) => {
  const appEnv = settings.appEnv

  const appId = useMemo(() => {
    if (!IntercomApps.has(appEnv)) return null
    return IntercomApps.get(appEnv)
  }, [appEnv])

  // Don't render Intercom at all if no valid appId
  // Passing empty string causes Intercom's internal code to crash
  if (!appId) {
    return <>{children}</>
  }

  return (
    <ProviderLib appId={appId} shouldInitialize>
      {children}
    </ProviderLib>
  )
}
